// extracted by mini-css-extract-plugin
export default {"pageTitle":"filterSection_pageTitle__sSTmK","desktop":"filterSection_desktop__TrtFN","modal":"filterSection_modal__QdMZL","content":"filterSection_content__aEDFB"};